import React from "react";
import "./cta-section.css";

export default function CtaSection() {
  return (
    <section className="cta-section">
      <div className="cta-inner">
        <h2 className="cta-title">SPREMAN ZA PRVI TRENING?</h2>
        <div className="cta-right">
          <p className="cta-text">
            Zakaži besplatne konsultacije i vidi zašto stotine klijenata bira
            Mihaila kao svog ličnog trenera.
          </p>
          <a href="/kontakt/" className="cta-btn">Zakaži trening</a>
        </div>
      </div>
    </section>
  );
}
